import React from "react";
import request from "superagent";
import crypto from "crypto-browserify";
import styled from "styled-components";

import makeid from "../utils/makeid";
import logger from "../utils/LoggerFrontend";
import Actions from "../Actions";
import {
  ALLOWED_VIDEO_FORMATS,
  ALLOWED_AUDIO_FORMATS,
  ALLOWED_IMAGE_FORMATS
} from "../PagesUser/SelfServiceCampaignCreation/Previews/constants";
import { UploadIcon } from "./Icons";

const StyledSpinner = styled.svg`
  animation: rotate 1s linear infinite;
  margin: 10px;
  width: 30px;
  height: 30px;

  & .path {
    stroke: #02df79;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

const Spinner = () => (
  <StyledSpinner viewBox="0 0 50 50">
    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="2" />
  </StyledSpinner>
);

const CLOUDINARY_CLOUD_ID = window.cloudinaryCloudId;
const CLOUDINARY_API_KEY = window.cloudinaryApiKey;
const CLOUDINARY_API_SECRET = window.cloudinaryApiSecret;
const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_ID}`;

const MAX_SIZE_VIDEO = 200_000_000;
const MAX_SIZE_IMAGE = 10_000_000;

const styleFileUpload = {
  position: "relative"
};

const styleInput = {
  color: "#1E22FF",
  fontWeight: 400,
  cursor: "pointer",
  opacity: 0,
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: "100%"
};

class UploadPhotoBtn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      upload: { url: props.image || "" },
      uploading: false
    };

    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.image !== prevProps.image) {
      this.setState({
        upload: {
          url: this.props.image
        }
      });
    }
  }

  // This method is being called when an upload was started.
  onFileChange(event) {
    const { allowVideos, allowImages = true } = this.props;

    let fileTypes = ALLOWED_IMAGE_FORMATS.concat(ALLOWED_VIDEO_FORMATS)
      .concat(ALLOWED_AUDIO_FORMATS)
      .concat(this.props.fileTypes || []);

    if (!allowVideos) {
      fileTypes = fileTypes.filter((type) => !ALLOWED_VIDEO_FORMATS.includes(type));
    }

    if (!allowImages) {
      fileTypes = fileTypes.filter((type) => !ALLOWED_IMAGE_FORMATS.includes(type));
    }

    const input = event.target;
    const uploadedFile = input?.files[0];

    if (!input || !uploadedFile) {
      logger.log("error:UploadPhotoBtn:onFileChange", "No input file found", {
        input,
        uploadedFile
      });
    }

    const extension = uploadedFile?.name?.split(".").pop().toLowerCase();
    const isAcceptableType = fileTypes.indexOf(extension) > -1;
    const isAudio = ALLOWED_AUDIO_FORMATS.includes(extension);
    const limit = ALLOWED_VIDEO_FORMATS.includes(extension) ? MAX_SIZE_VIDEO : MAX_SIZE_IMAGE;
    const limitInMB = limit / 1e6;

    let fileSizeIsValid = true;

    if (uploadedFile?.size > limit) {
      fileSizeIsValid = false;
      Actions.addNotification(`Das Bild ist zu groß (weniger < ${limitInMB} MB)`, "error");
    } else if (!isAcceptableType) {
      Actions.addNotification(`Invalid file type, allowed types: ${fileTypes.join(", ")}`, "error");
    }

    if (uploadedFile && fileSizeIsValid && isAcceptableType) {
      const reader = new FileReader();
      this.setState({ uploading: true });

      reader.onload = () => {
        logger.log("UploadPhotoBtn:onFileChange", "Start uploading file...upload:", {
          file: uploadedFile.name,
          folderName: this.props.folderName,
          context: this.props.context
        });

        // Upload to cloudinary
        const timestamp = (Date.now() / 1000) | 0;
        const contextValues = [];

        if (this.props.isLogo) {
          contextValues.push("type=logo");
          contextValues.push("assetType=image");
        } else if (ALLOWED_IMAGE_FORMATS.includes(extension)) {
          contextValues.push("type=image");
          contextValues.push("assetType=image");
        } else if (ALLOWED_VIDEO_FORMATS.includes(extension)) {
          contextValues.push("type=video");
          contextValues.push("assetType=video");
        } else if (isAudio) {
          contextValues.push("type=audio");
          contextValues.push("assetType=audio");
        }

        if (this.props.context) {
          contextValues.push(this.props.context);
        }

        let params = `timestamp=${timestamp}`;

        if (!isAudio) {
          params += "&transformation=q_auto";
        }

        // WARNING: the order of the string matters
        if (this.props.folderName) {
          params = `folder=${this.props.folderName || ""}&${params}`;
        }

        const context = contextValues.join("|");
        params = `context=${context}&${params}`;

        const signature = crypto
          .createHash("sha1")
          .update(`${params}${CLOUDINARY_API_SECRET}`)
          .digest("hex");

        logger.log("UploadPhotoBtn:onFileChange", "Start upload", {
          context,
          folderName: this.props.folderName,
          signature,
          timestamp,
          uploadedFile,
          CLOUDINARY_API_KEY
        });

        let upload = request
          .post(`${CLOUDINARY_UPLOAD_URL}/auto/upload`)
          .field("context", context || "")
          .field("folder", this.props.folderName || "")
          .field("api_key", CLOUDINARY_API_KEY)
          .field("signature", signature)
          .field("timestamp", timestamp)
          .field("file", uploadedFile);

        // If it's an audio file, we don't want to compress it
        if (!isAudio) {
          upload = upload.field("transformation", "q_auto");
        }

        upload.end((err, response) => {
          if (err) {
            logger.log("error:UploadPhotoBtn:onFileChange", "selectedFile...upload:", {
              err,
              response
            });

            Actions.addNotification(
              "Es ist ein Fehler beim hochladen der Datei aufgetreten.",
              "error"
            );
            return;
          }

          const { body } = response;

          if (body.secure_url) {
            logger.log("UploadPhotoBtn:onFileChange", "Finished uploading image", { body });

            this.setState({ uploading: false });

            const data = {
              name: body.public_id,
              url: body.secure_url,
              extension: body.format,
              height: body.height,
              width: body.width,
              type: "upload",
              etag: body.etag || "",
              phash: body.phash || ""
            };

            // Make sure to return the `type` as the 2nd argument,
            // since some of the callers use this information.
            this.props.handlePictureChanged(data, this.props.type || "Upload");

            Actions.addNotification("Das Bild wurde hochgeladen");

            this.setState({
              upload: data
            });
          } else {
            logger.log("error:UploadPhotoBtn:onFileChange", "No secure URL found", {
              response
            });
          }
        });
      };

      reader.readAsDataURL(uploadedFile);
    }
  }

  render() {
    const { upload, uploading } = this.state;
    const { showPreview, showLoading, label, buttonText, useUploadIcon } = this.props;

    const uploadId = makeid();

    return (
      <div>
        {showPreview && !showLoading && (
          <span>
            {label}
            <br />
          </span>
        )}

        {showPreview && upload && upload.url && (
          <div>
            <img src={upload.url} style={{ width: 100 }} />
          </div>
        )}

        {showLoading && uploading && <Spinner />}

        <div
          className="upload-btn-wrap"
          style={styleFileUpload}
          data-tip={this.props["data-tip"]}
          data-for={this.props["data-for"]}
        >
          <input
            id={"upload-btn-" + uploadId}
            type="file"
            style={styleInput}
            onChange={this.onFileChange}
          />
          <label htmlFor={"upload-btn-" + uploadId} style={{ cursor: "pointer" }}>
            {useUploadIcon ? <UploadIcon /> : buttonText || "+ Datei hochladen"}
          </label>
        </div>
      </div>
    );
  }
}

export default UploadPhotoBtn;
